import React from 'react';
import { IconProps } from '.';

export const Description2 = ({
  className,
  color = '#6E6B8C',
  width = '21',
  height = '21'
}: IconProps) => (
  <svg 
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M4.74265 3.04138C4.19774 3.04138 3.79108 3.53597 3.79108 4.09995C3.79108 4.66393 4.19774 5.15851 4.74265 5.15851L15.7651 5.15851C16.31 5.15851 16.7167 4.66393 16.7167 4.09995C16.7167 3.53597 16.31 3.04138 15.7651 3.04138L4.74265 3.04138Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M4.74265 7.10504C4.19774 7.10504 3.79108 7.59963 3.79108 8.16361C3.79108 8.72758 4.19774 9.22217 4.74265 9.22217L12.8367 9.22217C13.3816 9.22217 13.7883 8.72758 13.7883 8.16361C13.7883 7.59963 13.3816 7.10504 12.8367 7.10504L4.74265 7.10504Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M4.74265 15.2324C4.19774 15.2324 3.79108 15.727 3.79108 16.291C3.79108 16.855 4.19774 17.3495 4.74265 17.3495H15.7651C16.31 17.3495 16.7167 16.855 16.7167 16.291C16.7167 15.727 16.31 15.2324 15.7651 15.2324L4.74265 15.2324Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M4.74265 11.1687C4.19774 11.1687 3.79108 11.6633 3.79108 12.2273C3.79108 12.7912 4.19774 13.2858 4.74265 13.2858L17.3012 13.2858C17.8461 13.2858 18.2527 12.7912 18.2527 12.2273C18.2527 11.6633 17.8461 11.1687 17.3012 11.1687L4.74265 11.1687Z" fill={color} />
  </svg>
);
